// This sort of extends generic.js, but requires to be defined in plannerConfig.js
const nonEndPointRelated = (state = {}, action) => {
  switch (action.type) {
    case 'NOENDPOINT_SET_DATA':
      if (Array.isArray(state.data)) return { ...state, data: action.payload };
      return { ...state, data: { ...state.data, ...action.payload } };
    case 'NOENDPOINT_CLEAR_DATA':
      return { ...state, data: {} };
    default:
      return { ...state };
  }
};

export default nonEndPointRelated;
